<template lang="pug">
  transition(name='modal')
    .overlay.modal(@click.self="$emit('close')")
      #content.content
        h1.sess__title
          | {{ post.title[0] }} <br> {{ post.title[1] }}
        template(v-for='description in post.description')
          p.sess__description(v-html="description")
        .sess__speaker
          h2 登壇者
          speaker(:val='post.speakers' :prof='true')
        button.btn(@click="$emit('close')") 閉じる
</template>

<script>
import Speaker from "./Speaker.vue";

export default {
  components: {
    Speaker,
  },
  name: "Modal",
  props: ["post"],
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/_variables.scss";

.overlay {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  overflow: auto;
}

.content {
  position: relative;
  top: 0;
  z-index: 2;
  width: 100%;
  max-width: 860px;
  padding: 40px;
  margin: 0 auto;
  background-color: #fff;
}

.modal .sess__speaker {
  margin-top: 48px;
  margin-left: 0;
  margin-right: 0;
}

.modal .sess__speaker h2 {
  text-align: left;
  margin-bottom: 0;
  font-size: 1.2rem;
}

.modal .sess__title {
  color: #222;
  margin-left: 0;
  margin-right: 0;
}

.modal .sess__title::after {
  content: "";
  display: block;
  width: 100px;
  height: 4px;
  background-color: $secondary-color;
  position: absolute;
  bottom: -10px;
}

.modal {
  .sess__description + .sess__description {
    margin-top: 1rem;
  }
}

@media screen and (max-width: 768px) {
  .content {
    width: 96%;
  }
}

.modal-enter-active,
.modal-leave-active {
  opacity: 1;
  transform: scale(1);
  transition: opacity 0.5s;
}

.modal-enter-active .modal-content,
.modal-leave-active .modal-content {
  transition: 0.2s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
  transform: scale(0);
  transition: opacity 0.2s, transform 0s 1s;
}

.modal-enter .modal-content,
.modal-leave-to .modal-content {
  transform: scale(1);
}
</style>